import script from "./CabinetLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./CabinetLayout.vue?vue&type=script&setup=true&lang=js"

import "./CabinetLayout.vue?vue&type=style&index=0&id=2b352ba8&lang=scss"

const __exports__ = script;

export default __exports__